
const BASEURL = process.env.REACT_APP_API_URL;
const KEYACTION = process.env.REACT_APP_KEY;


export { BASEURL, KEYACTION };
